/**
 * Audit log (WP1-AUDIT, BUILD-PLAN 2.7, security-admin 4.6): the
 * practice-visible viewer with filters, saved views, a field-level diff
 * drawer, chain verification, anomaly alerts, numbered CSV exports and the
 * PHI-read coverage report. `/settings/audit?patient=<id>` opens it filtered
 * to one patient ("This patient").
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'audit',
    title: 'Audit log',
    version: '0.1.0',
    owner: 'WP1-AUDIT',
    entitlementKey: null,
    permissions: ['audit.view'],
    routes: [
      {
        id: 'log',
        path: '/settings/audit',
        title: 'Audit log',
        officeScope: 'location-or-all',
        permission: 'audit.view',
        // Patient names appear in the log; the API audits that read itself.
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Audit log',
        group: 'settings',
        routeId: 'log',
        icon: 'shield-check',
        order: 960,
        permission: 'audit.view',
      },
    ],
    commands: [
      {
        id: 'audit.open',
        title: 'Audit log',
        keywords: ['audit', 'history', 'hash chain', 'who changed', 'access log', 'hipaa'],
        routeId: 'log',
        permission: 'audit.view',
      },
    ],
    sseEntityKeys: ['audit_anomaly'],
  }),
  pages: {
    log: () => import('./pages/AuditPage.js'),
  },
});
